﻿import LfDataService from '../../../Services/LfDataService';
import LfWebService from '../../../Services/LfWebService';

import {
    pageHasErroredAction,
    pageErrorAction
} from '../../../State/actions';

export const fetchPossessionsStarted = (data) => {
    return {
        type: 'FETCH_POSSESSIONS_STARTED',
        data: data
    };
}

export const fetchPossessionsCompleted = (data) => {
    return {
        type: 'FETCH_POSSESSIONS_COMPLETE',
        data: data
    };
}

export const fetchMeta = (data) => {
    return {
        type: 'FETCH_METADATA',
        data: data
    };
}

export const fetchPossessionsData = () => {

    const lfDataService = new LfDataService();

    return (dispatch) => {
        let possessions;

        dispatch(fetchPossessionsStarted())

        lfDataService.getBasicCoverageData()
            .then(data => {
                possessions = data;

                dispatch(fetchPossessionsCompleted(possessions));

            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export const fetchMetaData = () => {

    const lfWebService = new LfWebService();

    return (dispatch) => {
        let meta;
        lfWebService.possessionsMetaData()
            .then(data => {
                meta = data;
                dispatch(fetchMeta(meta));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}